import * as React from "react";
const SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "none", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#212529", d: "M6.5 6.67 5 8.2l5 5.12 5-5.12-1.5-1.54-3.5 3.58z" }));
export default SvgChevronDown;
